import React from 'react'
import Layout from './Layout'
import useProps from './useProps'
import { Props } from './props'

export default (props: Props) => <Layout {...useProps(props)} />
